import { AreaLeavesDto } from 'src/types/area';

export enum UserAreaStatus {
    Confirmed = 'confirmed',
    Unconfirmed = 'unconfirmed',
}

export interface UserAreaState {
    area: AreaLeavesDto;
    status: UserAreaStatus;
}
